module.exports = __webpack_public_path__ + "static/img/back.92d4ce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 1